<template>
	<md-card>
		<md-card-header data-background-color="purple">
			<h4 class="title">ការកែប្រែព័ត៌មានគណនីអ្នកគ្រប់គ្រង</h4>
			<p class="category">សូមធ្វើការកែប្រែព័ត៌មាន</p>
		</md-card-header>
		<md-card-content>
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ឈ្មោះ</label>
						<md-input v-model="admin.name" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>លេខទូរស័ព្ទ</label>
						<md-input v-model="admin.phoneNumber" type="number" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ឈ្មោះចូលគណនី</label>
						<md-input v-model="admin.username" type="text" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>ប្រភេទគណនីយ</label>
						<md-select placeholder="ប្រភេទគណនីយ" v-model="admin.account_type" @md-selected="checkValidation()">
							<md-option value="ca">Call Center Administrator</md-option>
							<md-option value="sl">Accountant Administrator</md-option>
							<md-option value="ad">Operation Administrator</md-option>
							<md-option value="sa">Super Administrator</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>ពាក្យសំងាត់</label>
						<md-input v-model="admin.password" type="password" required @keyup="checkValidation()"></md-input>
					</md-field>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button :class="{'md-raised': true, 'md-primary': isValid}" @click="updateAdmin()" :disabled="!isValid">កែប្រែ</md-button>
				</div>
			</div>
		</md-card-content>
	</md-card>

</template>

<script>
	export default {
		created() {
			this.getAdmin();
		},
		data() {
			return {
				isValid: false,
				admin: {
					username: "",
					name: "",
					phoneNumber: "",
					password: "",
					account_type: ""
				}
			}
		},
		methods: {
			getAdmin() {
				this.$http.get(this.config.api + '/admin/admin/get/' + this.$route.params.id).then(data => {
					this.admin.admin_id = data.body.data.admin_id
					this.admin.name = data.body.data.name
					this.admin.username = data.body.data.username
					this.admin.phoneNumber = data.body.data.phone_number
					this.admin.account_type = data.body.data.account_type
				})
			},
			updateAdmin() {

				this.$http.post(this.config.api + "/admin/admin/update", {
					admin_id: this.admin.admin_id,
					username: this.admin.username,
					name: this.admin.name,
					phoneNumber: this.admin.phoneNumber,
					password: this.admin.password,
					account_type: this.admin.account_type
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Administrator information was updated successfully.",
							icon: 'done',
							type: 'success'
						})
						this.isValid = false
						this.getAdmin();
					}
				})
			},
			checkValidation() {
				this.admin.username = this.config.validateUsername(this.admin.username);
				if (this.admin.admin_id.length > 3 &&
					this.admin.name.length > 3 &&
					this.admin.username.length > 3 &&
					this.admin.phoneNumber.length > 8 &&
					this.config.validateUsername(this.admin.username) == this.admin.username) {

					this.isValid = this.admin.password.length == 0 || this.admin.password.length > 6 ? true : false
				} else {
					this.isValid = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Administrators/Edit.vue